/*
 * sr-video-lazy.js
 * ----------------
 * Para videos marcados con [data-sr-lazy-video]:
 *  - Browser ya tiene dimensiones (via <source src>) y preload="none" evita descarga.
 *  - IntersectionObserver llama .play() cuando entra al viewport (descarga on-demand).
 *  - Llama .pause() cuando sale (libera GPU/CPU/bandwidth).
 *  - Tap-to-play fallback si autoplay rechaza.
 *  - shopify:section:load handler para Theme Editor live preview.
 *  - Cero dependencias. Defer. Scoped por atributo.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  if (!('IntersectionObserver' in window)) {
    // Fallback: intentar play directamente
    document.querySelectorAll('video[data-sr-lazy-video]').forEach(function (v) {
      try { v.play().catch(function () {}); } catch (e) {}
    });
    return;
  }

  function tryPlay(v) {
    try {
      var p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          var host = v.closest('.sr-tst__tile, .sr-vid, .sr-how, .sr-vp__visual') || v.parentElement;
          if (host && !host.dataset.srTapBound) {
            host.dataset.srTapBound = '1';
            host.style.cursor = 'pointer';
            host.addEventListener('click', function (e) {
              if (e.target && e.target.tagName === 'A') return;
              v.play().catch(function () {});
            });
          }
        });
      }
    } catch (e) {}
  }

  function pauseVideo(v) {
    if (!v.paused) {
      try { v.pause(); } catch (e) {}
    }
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) tryPlay(v);
      else pauseVideo(v);
    });
  }, {
    rootMargin: '300px 0px',
    threshold: 0.01
  });

  function init() {
    document.querySelectorAll('video[data-sr-lazy-video]').forEach(function (v) {
      observer.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('video[data-sr-lazy-video]').forEach(function (v) {
      observer.observe(v);
    });
  });
})();
